export function bindSwatchesClick(selector) {
    document.querySelectorAll(`${selector} .product-card-shape-swatches:not(.bind-click)>a`).forEach(function(swatch) {
        swatch.addEventListener("click", function(event) {
            event.preventDefault();

            if (swatch.classList.contains('active')) {
                console.log("已选中的");
                return;
            }

            // 切换选中的swatch
            Array.from(swatch.parentElement.children).forEach(function(swatchA) {
                swatchA.classList.remove("active");
            });
            swatch.classList.add("active");
            const color = swatch.dataset.originalColor;
            console.log("color:", color);
            const productCard = swatch.closest('.product-card');
            productCard.setAttribute("data-selectcolor", color);
            const variants = JSON.parse(productCard.dataset.variants || "{}");

            // 设置跳转链接
            const productCardLink = productCard.querySelector(".product-card__link");
            productCardLink && (productCardLink.href = productCardLink.href.split('?')[0] + "?variant=" + variants[color].id);

            // 设置图片
            const img = productCard.querySelector(".product-card__images img");
            const featured_image = variants[color].featured_image;
            img.src = featured_image;
            const srcset = featured_image.split('?')[0];
            const srcsetValues = [
                `${srcset}?width=128 128w`,
                `${srcset}?width=240 240w`,
                `${srcset}?width=380 380w`,
                `${srcset}?width=540 540w`,
                `${srcset}?width=720 720w`,
                `${srcset}?width=1240 1240w`,
            ];
            img.setAttribute("data-srcset", srcsetValues.join(', '));
            img.setAttribute("srcset", srcsetValues.join(', '));
            img.onload = function() {
                //   {% comment %} 添加class，当通过加载更多加载出来的只执行新加载出来的 {% endcomment %}
                const imagesWrapper = productCard.querySelector(".product-card__images-wrapper");
                imagesWrapper.classList.add('product-card__color-filter');
                imagesWrapper.nextElementSibling.classList.add("hidden");
            }

            // 切换选中颜色对应size的可售状态和id
            const quickAddForm = productCard.querySelector(".quick-add-form");
            const productForms = quickAddForm.querySelectorAll('product-form');
            Object.entries(variants[color].size).forEach(([key, value], index) => {
                productForms[index].querySelector("input[name=id]").setAttribute("value", value.id);
                const quickAddSizeBtn = productForms[index].querySelector(".quick-add-size-btn");
                quickAddSizeBtn.setAttribute("data-disabled", !value.available);
                quickAddSizeBtn.querySelector("span[data-button-text]").textContent = key && key.split(" (")[0].trim();
            });
        });
        swatch.parentElement.classList.add("bind-click");
    });
}

// PC端加购size点击逻辑
export function bindQuickAddSizeBtnClick(selector) {
    const quickAddSizes =  document.querySelectorAll(`${selector} .quick-add-sizes:not(.bind-click)`);
    quickAddSizes.forEach(function(quickAddSize) {
        quickAddSize.classList.add('bind-click');
        quickAddSize.querySelectorAll(".quick-add-size-btn:not([data-disabled=true])").forEach(function(btn) {
            btn.addEventListener("click", function() {
                const quickAddForm = btn.closest(".quick-add-form");
                const quickAddTip = quickAddForm.nextElementSibling;
                quickAddTip.style.display = "block";
                quickAddForm.style.display = 'none';

                setTimeout(function() {
                    quickAddTip.style.display = "none";
                    quickAddForm.style.display = 'flex';
                }, 1000);
            });
        });
    });
}

// 移动端图片右下角加购按钮点击事件
export function bindQuickAddMobileClick(selector) {
    const quickAddMobiles = document.querySelectorAll(`${selector} .quick-add-mobile:not(.bind-click)`);
    quickAddMobiles.forEach(function(quickAddMobile) {
        quickAddMobile.classList.add("bind-click");
        quickAddMobile.querySelector(".quick-add-button-container").addEventListener("click", function() {
            // 动态设置color对应的size            
            const productCard = quickAddMobile.closest('.product-card');
            const selectColor = productCard.dataset.selectcolor || 'default';
            const variants = JSON.parse(productCard.dataset.variants);
            const size = variants[selectColor].size;
            let html = "";

            Object.entries(size).forEach(([key, value], index) => {
                html = html + `
                        <product-form>
                            <form method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="id" value="${value.id}" data-product-form-variant="">
                                <button type="submit" name="add" 
                                    data-disabled="${!value.available}"
                                    class="quick-add-size-btn"
                                    aria-label="Add to cart">
                                    <div role="option" aria-checked="false" aria-selected="true" class="item ${value.available ? "" : "disabled"}" style="pointer-events: all;">
                                        <div class="size-option small-p black">
                                            <span data-button-text="">${value.available ? (key && key.split(" (")[0].trim()) : key + " - Sold Out Online"}</span>
                                        </div>
                                        <div class="divider"></div>
                                    </div>
                                </button>
                            </form>
                        </product-form>
                `
            });
            const quickAddContainer = document.querySelector(".quickAddContainer>div");
            const menu = quickAddContainer.querySelector('.menu');
            const items = menu.querySelectorAll("product-form");
            items.forEach(item => item.remove());
            menu.insertAdjacentHTML('beforeend', html);

            // 显示弹出层color对应的size
            quickAddContainer.style.cssText = "position: fixed; width: 100vw; height: 100vh; top: 0px; left: 0px; z-index: 201;";
            const dropdown = quickAddContainer.querySelector(".quick-add-variant-selection-dropdown");
            dropdown.classList.add("active", "visible");
            dropdown.setAttribute("aria-expanded", true);
            menu.classList.add("visible");
            const dimmer = quickAddContainer.querySelector(".dimmer");
            dimmer.classList.add("visible");
            dimmer.style.cssText = "opacity: 0.65; display: flex !important;";
            setTimeout(function() {
                dropdown.classList.add("animated");
            }, 100);
        });
    });
}

// 移动端加购按钮点击弹出层,绑定隐藏事件
function bindMobileQuickAddContainerhidden() {
    function mobileQuickAddContainerhidden() {
        const quickAddContainer = document.querySelector(".quickAddContainer>div");
        quickAddContainer.style.cssText = "";
        const dropdown = quickAddContainer.querySelector(".quick-add-variant-selection-dropdown");
        dropdown.classList.remove("active", "visible", "animated");
        dropdown.setAttribute("aria-expanded", false);
        const menu = quickAddContainer.querySelector(".menu");
        menu.classList.remove("visible");
        const dimmer = quickAddContainer.querySelector(".dimmer");
        dimmer.classList.remove("visible");
    }

    const quickAddContainer = document.querySelector(".quickAddContainer");
    // 当中❌按钮点击事件绑定
    const selectorCloseIcon = quickAddContainer.querySelector(".selector-close-icon");
    selectorCloseIcon.addEventListener("click", mobileQuickAddContainerhidden);
    // 阴影层绑定
    const dimmer = quickAddContainer.querySelector(".dimmer");
    dimmer.addEventListener("click", mobileQuickAddContainerhidden);
    // menu当中点击绑定
    const menu = quickAddContainer.querySelector(".menu");
    menu.addEventListener("click", function(event) {
        if (event.target && (event.target.matches('.disabled') || event.target.parentElement.matches('.disabled') || event.target.parentElement.parentElement.matches('.disabled'))) {
            return;
        }
        if (event.target && (event.target.matches('.item') || event.target.matches('.size-option') || event.target.matches('span'))) {
            mobileQuickAddContainerhidden();
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    bindMobileQuickAddContainerhidden();
});